// See MIME types here
// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
export const CSV_FILE_TYPE = { 'text/csv': ['.csv'] };
export const JPEG_FILE_TYPE = { 'image/jpeg': ['.jpeg', '.jpg'] };
export const GIF_FILE_TYPE = { 'image/gif': ['.gif'] };
export const PNG_FILE_TYPE = { 'image/png': ['.png'] };
export const PDF_FILE_TYPE = { 'application/pdf': ['.pdf'] };
export const MSWORD_FILE_TYPE = { 'application/msword': ['.doc'] };
export const MSOFFICE_FILE_TYPE = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
    '.docx',
  ],
};
